/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface V1MotiWorkoutsFeed
 */
export interface V1MotiWorkoutsFeed {
    /**
     *
     */
    userId: string
    /**
     *
     */
    photo?: string
    /**
     *
     */
    excircise: string
    /**
     *
     */
    progress: number
    /**
     *
     */
    state?: V1MotiWorkoutsFeedStateEnum
}

/**
 * @export
 */
export const V1MotiWorkoutsFeedStateEnum = {
    Start: 'start',
    Stop: 'stop'
} as const
export type V1MotiWorkoutsFeedStateEnum =
    (typeof V1MotiWorkoutsFeedStateEnum)[keyof typeof V1MotiWorkoutsFeedStateEnum]

/**
 * Check if a given object implements the V1MotiWorkoutsFeed interface.
 */
export function instanceOfV1MotiWorkoutsFeed(
    value: object
): value is V1MotiWorkoutsFeed {
    if (!('userId' in value) || value['userId'] === undefined) return false
    if (!('excircise' in value) || value['excircise'] === undefined)
        return false
    if (!('progress' in value) || value['progress'] === undefined) return false
    return true
}

export function V1MotiWorkoutsFeedFromJSON(json: any): V1MotiWorkoutsFeed {
    return V1MotiWorkoutsFeedFromJSONTyped(json, false)
}

export function V1MotiWorkoutsFeedFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1MotiWorkoutsFeed {
    if (json == null) {
        return json
    }
    return {
        userId: json['userId'],
        photo: json['photo'] == null ? undefined : json['photo'],
        excircise: json['excircise'],
        progress: json['progress'],
        state: json['state'] == null ? undefined : json['state']
    }
}

export function V1MotiWorkoutsFeedToJSON(json: any): V1MotiWorkoutsFeed {
    return V1MotiWorkoutsFeedToJSONTyped(json, false)
}

export function V1MotiWorkoutsFeedToJSONTyped(
    value?: V1MotiWorkoutsFeed | null,
    ignoreDiscriminator: boolean = false
): any {
    if (value == null) {
        return value
    }

    return {
        userId: value['userId'],
        photo: value['photo'],
        excircise: value['excircise'],
        progress: value['progress'],
        state: value['state']
    }
}
